import React from 'react';
import { TextInput, Tooltip } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons';

interface SubdomainInputProps {
  placeholder: string;
  label?: string;
  description?: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
  disabled?: boolean;
}

export const SubdomainInput: React.FC<SubdomainInputProps> = ({
  placeholder,
  label = 'Domain',
  description,
  value,
  onChange,
  error,
  disabled = false,
}) => {
  const rightSection = description ? (
    <Tooltip 
      label={description}
      position="top-end"
      withArrow
      multiline
      width={220}
    >
      <IconInfoCircle size={16} style={{ display: 'block', opacity: 0.5 }} />
    </Tooltip>
  ) : null;

  return (
    <TextInput
      // label={label}
      placeholder={placeholder}
      value={value}
      onChange={(e) => onChange(e.currentTarget.value)}
      error={error}
      rightSection={rightSection}
      styles={{
        label: {
          marginBottom: 4
        }
      }}
      disabled={disabled}
    />
  );
}; 